import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    background: theme.palette.primary.main,
    backgroundImage: `linear-gradient(180deg, ${theme.palette.primary.dark} 65%, ${theme.palette.primary.main} 99%)`,
    display: 'grid',
    width: '100%',
    minHeight: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
    [theme.breakpoints.only('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '4fr 8fr',
    },
  },
  wrapper: {
    width: '100%',
    minHeight: 560,
    background: theme.palette.white,
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
    },
  },
  leftLogo: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(5),
    minHeight: 100,
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
      gap: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  dponetLogo: {
    maxHeight: '100%',
    height: 'auto',
    maxWidth: '20vw',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '240px',
    },
  },
}))

export default styles
